import { Component, OnInit } from "@angular/core";
import { UserService } from "src/app/services/user.service";

@Component({
  selector: "app-approval",
  templateUrl: "./approval.component.html",
  styleUrls: ["./approval.component.css"],
})
export class ApprovalComponent implements OnInit {
  selectedTabIndex = 0
  currentUser
  onTabChange(index) {
    this.selectedTabIndex = index;
  }
  get currentType() {
    switch (this.selectedTabIndex) {
      case 0: return 'forecast';
      case 1: return 'performance';
      case 2: return 'check';
      default: return 'forecast';
    }
  }
  constructor(public userService: UserService) {
 
  }

  async ngOnInit() {
    this.currentUser = await this.userService.getCurrentUser().toPromise()
  }

  canSeeChequeApproval() {
    if (this.currentUser) {
      return ['FINANCIAL_MANAGER_ADMINISTRATOR','FINANCIAL_MANAGER_ADMINISTRATOR_AND_PROPERTIES_LECTEUR','MAYOR_TREASURER','CENTRAL_READER','ADMIN','CENTRAL_EDITOR','FINANCIAL_EDITOR'].includes(this.currentUser.role)
      return true
    }
    return false
  }

  canSeeForecastPerformance() {
    if (this.currentUser) {
      return !['FINANCIAL_MANAGER_ADMINISTRATOR','FINANCIAL_MANAGER_ADMINISTRATOR_AND_PROPERTIES_LECTEUR','MAYOR_TREASURER','CENTRAL_READER'].includes(this.currentUser.role)
      return true
    }
    return false
  }
}
